export type { MediaProps, Midia } from './Media'
export { default as Media } from './Media'
